import $ from 'jquery';
import Util from '../utils/ui';
import * as CONST from '../utils/constants';

class BackToHealthPage {
	constructor() {
	}

	init() {
		this.bindEvents();
	}

	bindEvents() {
		$(document).ready(() => {
			let { referrer } = document;
			if (window.location.search.indexOf('?fromWheel=true') >= 0) {
				let string = '<div class="back-to-heath-bottom-section"><div class="global-container back-to-health-bottom-section-wrapper"><div class="icon-lung-wraper"><span class="icon-lungs"></span></div><div class="copy-wrapper"><h2>Creating Lung Friendly Communities for Youth</h2><div class="back-text">Strategies for addressing asthma, tobacco, Indoor Air Quality and more in schools and community organizations</div><a href="/professional-education/health-index" class="btn accent-btn">Return to Lung Friendly Resources</a></div></div></div>';
				// good - Right way to convert html string to jQuery object
				let backtoHealthBottomElement = $($.parseHTML(string));
				$('main').append(backtoHealthBottomElement);
				if (window.outerWidth < 998) {
					$('<a>', {
						class: 'back-to-health-mobile icon-arrow-left',
						href: referrer,
						text: 'BACK TO LUNG FRIENDLY RESOURCES'
					}).appendTo('header');
				} else {
					$('<a>', {
						id: 'js-back-to-health',
						class: 'back-to-health icon-arrow-left',
						href: referrer,
						text: 'BACK TO LUNG FRIENDLY RESOURCES'
					}).appendTo('main');

					$('<a>', {
						id: 'js-back-to-health-scroll',
						class: 'back-to-health-scroll icon-arrow-left',
						href: referrer,
						text: 'BACK TO RESOURCES',
						style: 'display:none;'
					}).appendTo('main');

					let topofDiv = $('#js-back-to-health').offset().top;
					let height = $('#js-back-to-health').outerHeight();

					$(window).scroll(() => {
						if ($(window).scrollTop() < (topofDiv + height)) {
							$('#js-back-to-health').show();
							$('#js-back-to-health-scroll').hide();
						}
						else {
							$('#js-back-to-health').hide();
							$('#js-back-to-health-scroll').show();
						}
					});
				}
			}
		});
	}

	toggleExpandedContent(e) {
	}
}
export default BackToHealthPage;
$(() => {
	const backToHealthPage = new BackToHealthPage();
	backToHealthPage.init();
});